<template>
  <div class="message-modal">
    <s-modal
      v-if="currentMessage"
      v-model="visible"
      hide-header-close
      :hide-header="!currentMessage.title"
      :title="$t(currentMessage.title, currentMessage.titleParams)"
      :ok-only="!currentMessage.confirmation"
      :ok-title="$t(okTitle)"
      :cancel-title="$t(cancelTitle)"
      :size="currentViewOptions.size"
      @ok="ok()"
      @cancel="cancel()"
      @hidden="onHideModal()"
    >
      <div
        class="message-modal__message"
        v-html="$t(currentMessage.message, currentMessage.messageParams )"
      ></div>
      <template slot="modal-footer">
        <b-row
          align-h="end"
          no-gutters
        >
          <b-col
            v-for="(button, idx) in currentViewOptions.extraButtons"
            class="mb-2 pl-sm-3"
            cols="12"
            sm="auto"
            :key="idx"
          >
            <b-button
              v-if="showExtraButtons"
              block
              :variant="button.variant || 'secondary'"
              :class="footerButtonClasses"
              @click="fileExtraButtonClick(button)"
            >
              {{ button.labelPath ? $t(button.labelPath) : button.label }}
            </b-button>
          </b-col>
          <b-col
            class="pl-sm-3"
            cols="12"
            sm="auto"
          >
            <b-button
              v-if="currentMessage.confirmation"
              block
              variant="secondary"
              :class="footerButtonClasses"
              @click="manualCancel()"
            >
              {{ $t(cancelTitle) }}
            </b-button>
          </b-col>
          <b-col
            class="mt-2 mt-sm-0 pl-sm-3"
            cols="12"
            sm="auto"
          >
            <b-button
              block
              variant="primary"
              :class="footerButtonClasses"
              @click="manualOk()"
            >
              {{ $t(okTitle) }}
            </b-button>
          </b-col>
        </b-row>
      </template>
    </s-modal>
  </div>
</template>

<script>
import { messages, onNewMessage } from '@/services/messages/messageService';
import ConfirmationTypes from '@/constants/confirmationTypes';

const DEFAULT_VIEW_OPTIONS = {};

export default {
  components: {
  },
  props: {},
  data() {
    return {
      currentMessage: null,
      visible: false,
    };
  },
  methods: {
    ok() {
      this.currentMessage.accept();
    },
    cancel() {
      this.currentMessage.reject();
    },
    manualOk() {
      this.visible = false;
      this.ok();
    },
    manualCancel() {
      this.visible = false;
      this.cancel();
    },
    onHideModal() {
      this.refreshMessage();
    },
    refreshMessage() {
      [this.currentMessage] = messages;
      this.visible = !!this.currentMessage;
    },
    fileExtraButtonClick(button) {
      if (button.cancelOnClick !== false) {
        this.manualCancel();
      }
      button.click();
    },
  },
  computed: {
    showExtraButtons() {
      return Array.isArray(this.currentViewOptions.extraButtons);
    },
    okTitle() {
      if (this.currentMessage) {
        if (this.currentMessage.confirmation === true
          || this.currentMessage.confirmation === ConfirmationTypes.YES_NO) {
          return 'general.yes';
        }
        return 'general.ok';
      }
      return null;
    },
    cancelTitle() {
      if (this.currentMessage) {
        if (this.currentMessage.confirmation === true
          || this.currentMessage.confirmation === ConfirmationTypes.YES_NO) {
          return 'general.no';
        }
        if (this.currentMessage.confirmation === ConfirmationTypes.OK_CANCEL) {
          return 'general.cancel';
        }
        return null;
      }
      return null;
    },
    footerButtonClasses() {
      return this.currentViewOptions.buttonsClasses;
    },
    currentViewOptions() {
      return this.currentMessage.viewOptions || DEFAULT_VIEW_OPTIONS;
    },
  },
  created() {
    this.cancelNewMessageListener = onNewMessage(() => this.refreshMessage());
    this.refreshMessage();
  },
  destroyed() {
    this.cancelNewMessageListener();
  },
};
</script>

<style lang="sass" scoped>
  @import src/styles/defaults/variables
  @import "src/styles/defaults/mobile-first"

  .message-modal
    &__message
      word-wrap: break-word !important
    ::v-deep
      .modal-footer
        +media-xs()
          flex-wrap: wrap
          > *
            margin-bottom: .5em
            margin-left: 0
            margin-right: 0
            width: 100%
</style>
